module.exports = __webpack_public_path__ + "static/media/rose.9438a440.svg";